import { createApp } from 'vue'
import FeedbackApp from './FeedbackApp'

const appElement = document.getElementById('form-feedback-app')

const app = createApp(FeedbackApp, {
    policy_url: appElement.getAttribute('policy_url'),
    policy_private_url: appElement.getAttribute('policy_private_url'),
})

app.mount('#form-feedback-app')
